<template>
  <app-layout>
    <template #header>
      <div class="text-center">
        <h1 class="text-2xl mb-6">
          Bestellübersicht
        </h1>
      </div>
    </template>
    <template #default>
      <OrderCalendar />
    </template>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import OrderCalendar from '@/Components/Calendar/OrderCalendar'

export default {
  components: {
    AppLayout,
    OrderCalendar,
  },
}
</script>
